import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Row, Icon, Typography, Popconfirm, List } from 'antd'
const { Paragraph } = Typography
import { drugs } from '@services/api'
import { toJS } from 'mobx'

@inject((store: any) => {
    const { popupStore, authStore, drugsStore } = store
    return { popupStore, authStore, drugsStore }
})
@observer
export default class extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = { addFilter: '' }
        this.closePopup = this.closePopup.bind(this)
    }

    closePopup() {
        this.setState({ addFilter: '' })
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const {
            popupStore: { popupType, info },
            drugsStore: { families, getDrugs },
            authStore: { fullName }
        } = this.props
        const { addFilter } = this.state
        let JSInfo = toJS(info)
        const footerButtons = (
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <Button onClick={this.closePopup}>סגור</Button>
            </div>
        )
        let rowStyle = {
            display: 'flex',
            borderBottom: 'solid',
            borderBottomColor: 'black',
            borderBottomWidth: 1
        }

        let marginRight = { marginRight: 15, marginTop: 9 }
        return (
            <Modal
                title={`הוסף או הסר משפחה מתרופה`}
                visible={popupType === 'DrugFamilies'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
                width={1200}
            >
                {popupType === 'DrugFamilies' && families.length ? (
                    <div style={{ textAlign: 'center' }}>
                        <h5>הסר</h5>
                        {JSInfo.drugGroupDrugs.map(group => (
                            <Row key={group.id} gutter={28} style={{ ...rowStyle }}>
                                <Paragraph>{families.find(family => family.id == group.group_drug_id).name}</Paragraph>
                                {!!group.updated_by && (
                                    <Popconfirm
                                        placement="topLeft"
                                        title={'האם ברצונך להסיר את הקישור למשפחה?'}
                                        onConfirm={async () => {
                                            await drugs.dltRelation({
                                                group_drug_id: group.group_drug_id,
                                                drug_id: JSInfo.id
                                            })
                                            await getDrugs()
                                            this.closePopup()
                                        }}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Icon style={marginRight} type="delete" onClick={() => {}} />
                                    </Popconfirm>
                                )}
                            </Row>
                        ))}
                        <h5>הוסף</h5>
                        <input
                            placeholder="סנן משפחות"
                            value={addFilter}
                            onChange={e => this.setState({ addFilter: e.target.value })}
                        />
                        <List
                            rowKey="id"
                            dataSource={families.filter(
                                family =>
                                    !JSInfo.drugGroupDrugs.map(dgd => dgd.group_drug_id).includes(family.id) &&
                                    family.name.includes(addFilter)
                            )}
                            pagination={{
                                hideOnSinglePage: true,
                                perPage: 10
                            }}
                            renderItem={item => (
                                <List.Item>
                                    <Paragraph>{item.name}</Paragraph>
                                    <Icon
                                        style={marginRight}
                                        type="check"
                                        onClick={async () => {
                                            await drugs.addRelation({
                                                group_drug_id: item.id,
                                                drug_id: JSInfo.id,
                                                updated_by: fullName
                                            })
                                            await getDrugs()
                                            this.closePopup()
                                        }}
                                    />
                                </List.Item>
                            )}
                        />
                    </div>
                ) : (
                    ''
                )}
            </Modal>
        )
    }
}
